<div style="display: flex; gap: 5px; margin-left: 10px; margin-right: 5px">
  <p-checkbox
    [inputId]="id"
    [name]="name"
    [value]="value"
    [ngModel]="checked"
    [binary]="true"
    [indeterminate]="indeterminate"
    [disabled]="disabled"
    (ngModelChange)="onCheckChange({checked: $event})"
  />
  <label *ngIf="label" [for]="name" class="ml-2"> {{ label }} </label>
</div>
